const M = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMSAxOC41ODU4VjNIMTNWMTguNTg1OEwxOS4yOTI5IDEyLjI5MjlMMjAuNzA3MSAxMy43MDcxTDEyIDIyLjQxNDJMMy4yOTI4OSAxMy43MDcxTDQuNzA3MTEgMTIuMjkyOUwxMSAxOC41ODU4WiIvPgo8L3N2Zz4K";
export {
  M as default
};
//# sourceMappingURL=down-1ef06b56.mjs.map
